import React, { useMemo, Fragment, } from 'react';
import { omit, last, isEmpty, orderBy, sortBy, keyBy, } from 'lodash';
import { toast } from 'react-toastify';
import { format as formatDate, startOfDay, endOfDay, } from 'date-fns';
import numeral from 'numeral';

import firebase, { functions } from '../../firebase';
import { fetchPdf, } from '../../util';
import { colors, } from '../../shared/config';
import { canUpdateSupplier } from '../../shared/abilities';
import AdminPage from '../hocs/AdminPage';
import ModelFormModal from '../modals/ModelFormModal';
import useCollectionSubscriptionInTenant from '../hooks/useCollectionSubscriptionInTenant';
import useQueryParams from '../hooks/useQueryParams';
import AddInTenantButton from '../AddInTenantButton';
import EditButton from '../EditButton';
import DeleteButton from '../DeleteButton';
import ModalButton from '../ModalButton';
import QuerySortLabel from '../QuerySortLabel';
import InventoriesHeader from '../InventoriesHeader';
import { fields, locales, currencies, } from '../../shared/models/supplier';
import QuerySelector from '../QuerySelector';
import QueryDateRangeSelector from '../QueryDateRangeSelector';
import ProgressButton from '../ProgressButton';

const { keys, entries } = Object;
const db = firebase.firestore();
const storageRef = firebase.storage().ref();
const sendSupplier = functions.httpsCallable('sendSupplier');

export default AdminPage(function AdminInventoriesSchedule (props) {
  const { tenant, user } = props;
  const queryParams = useQueryParams();
  const suppliers = sortBy(useCollectionSubscriptionInTenant(db.collection('suppliers')), 'name');

  return (
    <div>
      <div className="admin-purchase-orders container-fluid py-5 position-relative bg-white">
        <InventoriesHeader activeTab="suppliers" />
        <div className="mt-4 d-flex justify-content-end mb-3">
          <AddInTenantButton itemRef={db.collection('suppliers').doc()} FormModal={ModelFormModal} formProps={{ title: '仕入先', fields, }} disabled={!canUpdateSupplier(user)} />
        </div>
        <div>
          {
            suppliers.length > 0 ? (
              <table className="table table-bordered table-sm">
                <thead className="thead-light text-center">
                  <tr>
                    <th>
                    </th>
                    <th>
                      名称
                    </th>
                    <th>
                      言語
                    </th>
                    <th>
                      通貨
                    </th>
                    <th>
                      メールTO
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {
                    suppliers.map((supplier) => {
                      const { id, ref, name, locale, currency, emailTo, } = supplier;

                      return (
                        <tr key={id}>
                          <td className="text-nowrap">
                            <EditButton itemRef={ref} FormModal={ModelFormModal} formProps={{ title: '仕入先', fields, }} disabled={!canUpdateSupplier(user)} />
                            <DeleteButton itemRef={ref} className="ml-1" disabled={!canUpdateSupplier(user)} />
                          </td>
                          <td>
                            {name}
                          </td>
                          <td>
                            {locales[locale]?.label}
                          </td>
                          <td>
                            {currencies[currency]?.label}
                          </td>
                          <td>
                            {emailTo}
                          </td>
                        </tr>
                      );
                    })
                  }
                </tbody>
              </table>
            ) : (
              <div>
                仕入先は未登録です
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
});
